function capitalize(value) {
  return value[0].toUpperCase().concat(value.slice(1));
}
function uncapitalize(value) {
  return value[0].toLowerCase().concat(value.slice(1));
}
function camelcasify(value) {
  const [first, ...rest] = value.split(/[-_]/g);
  return uncapitalize(first).concat(...rest.map((r) => capitalize(r)));
}
function pascalcasify(value) {
  return "".concat(...value.split(/[-_]/g).map((r) => capitalize(r)));
}
function kebabcasify(value) {
  return value.replace(/[A-Z]/g, (match, offset) => {
    if (offset === 0) {
      return match.toLowerCase();
    }
    return `-${match.toLowerCase()}`;
  });
}

export { camelcasify, capitalize, kebabcasify, pascalcasify, uncapitalize };
/*                              */
